var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{attrs:{"span":18,"offset":3}},[_c('div',{staticClass:"gird-content"},[_c('div',{staticStyle:{"width":"1024px","height":"500px"},attrs:{"id":"editor","type":"text/plain"}}),_vm._v(" "),_c('el-button',{attrs:{"type":"info"},on:{"click":_vm.getUedtorContent}},[_vm._v("保存")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-199e518b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ueditor.vue
// module id = null
// module chunks = 